import { WizardContainerController } from './wizard-container.controller';
import { WizardContainerComponentProps } from './wizard-container.model';

const WizardContainer = (props: WizardContainerComponentProps): JSX.Element => {
  return <WizardContainerController {...props} />;
};
export default WizardContainer;
